import { View } from './View.js';

class RelatedItemsView extends View {
	_parentElement = document.querySelector('.relatedItems-content');

	//Add Handler to the prev and next btns
	addHandlerClick(handle) {
		this._parentElement.addEventListener('click', function (e) {
			const btn = e.target.closest('.btn--inline');
			console.log(btn);
			const gotoPage = +btn.dataset.goto;
			console.log('gotoPage is :', gotoPage);
			handle(gotoPage);
		});
	}

	_generateMarkUp() {
		this._parentElement = document.querySelector('.relatedItems-content');

		return this._pageData.items.map(this._generateMarkUpPreview).join('');
	}

	_generateMarkUpPreview(item) {
		return ` 
		<div class="letter-box">
			<img class="letter-box__img" src="${item.imgfilename}" alt="${item.title}">
			<div class="letter-box__data">
				<h2 class="letter-box__title">${item.title}</h2>
				<p class="letter-box__desc">${item.desc}</p>
				<a  class="letter-box__display" 
				href="#${item.id}">عرض</a>
			</div>
		</div>
		`;
	}

	//
}

export default new RelatedItemsView();
